export const TableColumnsFilterStatus = {
  REQUEST: 'Table_Columns_Filter_REQUEST',
  SUCCESS: 'Table_Columns_Filter_SUCCESS',
  ERROR: 'Table_Columns_Filter_ERROR',
  RESET: 'Table_Columns_Filter_RESET',
};
